import {combineReducers} from 'redux';
import system from './system';
import translations from './translations';
import property from './property';

/**
 * Connect reducers to the redux store.
 */

/* istanbul ignore next */
const reducers = combineReducers({
    system,
    translations,
    property
});

export default reducers;
